import { useContext, useEffect, useState } from 'react';
import { api } from 'api/api';
import { AccountContext } from 'components/AccountContext';
import { userIsSubscriber } from 'components/Utils/theme';

const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

const useModelAtendimentoPresencial = () => {
  const { user } = useContext(AccountContext);
  const assinante = userIsSubscriber(user);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [valores, setValores] = useState({
    valor_exames: 0,
    valor_consulta: 0,
    valor_odonto: 0,
    valor_outros: 0,
  });

  async function fetchValoresPresenciais() {
    try {
      setLoading(true);
      setError(false);
      const url = `${ENDPOINT}/pacientes/pesquisarValoresPresenciais`;
      const postsData = await api(`${url}`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username: user.username,
          assinante: assinante,
          plano_id: user.id_plano,
          lat: user.coords && user.coords.latitudeAtual ? user.coords.latitudeAtual : null,
          lng: user.coords && user.coords.longitudeAtual ? user.coords.longitudeAtual : null,
          city: user.cidade,
        }),
      });
      const response = await postsData.json();
      console.log('Resposta da API de valores presenciais:', response);
      const cacheObj = {
        valores: response,
        userKey: `${user.username || ''}_${user.id_plano || ''}`,
      };
      sessionStorage.setItem('dashboardValoresPresenciais', JSON.stringify(cacheObj));
      setValores(response);
    } catch (error) {
      console.error('Erro ao buscar valores presenciais:', error);
      setError(true);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchValoresPresenciais();
  }, [user.username, user.id_plano, user.loggedIn]);


  return {
    valores,
    error,
    loading,
  };
};

export default useModelAtendimentoPresencial;
